export default {
    pageName: 'Leave Request',
    leaveType: {
        title: 'Leave Type',
        placeholder: '- Leave Type -',
        single: 'Single Day',
        range: 'Range',
        require: 'Leave Type is required'
    },
    startDate: {
        title: 'Start Date',
        placeholder: '- Start Date -'
    },
    endDate: {
        title: 'End Date',
        placeholder: '- End Date -',
        require: 'Date is required'
    },
    attachFile: {
        title: 'Attach File',
        select: 'Image'
    },
    reason: {
        title: 'Reason',
        placeholder: 'Detail of your leave',
        invalid: 'Reason is max size 250 characters',
        require: 'Reason is required'
    },
    button: {
        cancel: 'Cancel',
        submit: 'Submit'
    },
    modalSuccess: {
        title: 'Success',
        body: 'Your request has been sent',
        btnOk: 'CONFIRM'
    },
    modalFail: {
        title: 'Sorry, unable to process',
        body: '',
        btnOk: 'CLOSE'
    },
    uploadYourPhoto: 'Upload your attach file',
    successModal: 'Your request has been sent'
}
